export enum ProposalFilteringOptionsEnum {
    ALL = "Wszystkie",
    ACCEPTED = "Zaakceptowane",
    DECLINED= "Odrzucone",
    IN_PROGRESS= "Oczekujące"
}